import React from 'react';
import { string } from 'prop-types';
import TooltipButton from '../TooltipButton';

const HelpButton = ({ content }) => (
  <TooltipButton content={content}>
    <span className="icon--question helpIcon" />
  </TooltipButton>
);

HelpButton.propTypes = {
  content: string.isRequired
};

export default HelpButton;
